import React, { useState } from "react";
import { SlArrowLeft } from "react-icons/sl";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { addPass } from "../redux/passSlice"; // Adjust the import path based on your project structure
import { message } from "antd";
const Pass = () => {
  const [formData, setFormData] = useState({
    name: "",
    vehicleno: "",
    vehicletype: "",
    date: "",
    time: "",
  });

  const [errors, setErrors] = useState({});
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { loading, error } = useSelector((state) => state.passes);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  const validateForm = () => {
    const errors = {};
    let isValid = true;

    if (!formData.name.trim()) {
      errors.name = "Name is required";
      isValid = false;
    }

    if (!formData.vehicleno.trim()) {
      errors.vehicleno = "Vehicle number is required";
      isValid = false;
    }

    if (!formData.vehicletype.trim()) {
      errors.vehicletype = "Vehicle type is required";
      isValid = false;
    }

    if (!formData.date) {
      errors.date = "Date is required";
      isValid = false;
    }

    if (!formData.time) {
      errors.time = "Time is required";
      isValid = false;
    }

    setErrors(errors);
    return isValid;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (validateForm()) {
      const userData = JSON.parse(localStorage.getItem("user"));
      const { id, name: invitedBy } = userData.user;

      const passData = {
        user_id: id,
        guest_name: formData.name,
        vehicle_number: formData.vehicleno,
        vehicle_type: formData.vehicletype,
        date: formData.date,
        visit_time: formData.time,
        invited_by: invitedBy,
        status: 1,
      };

      try {
        const response = await dispatch(addPass(passData)).unwrap();

        // Assuming the response contains the OTP (check the actual structure of your response)
        const otp = response.otp_code; // Or whatever the key is in the response

        // Save OTP to localStorage
        localStorage.setItem("otp", JSON.stringify({ otp_code: otp }));
        message.success("Pass generated successfully");
        if (userData?.user?.role_name[0] === "apartment_user") {
          navigate("/pass");
        } else {
          navigate("/dashboard/pass");
        }
      } catch (err) {
        console.error("Failed to add pass:", err);
        message.error("Error: " + (String(err.errors) || "Failed to add pass"));
      }
    }
  };

  return (
    <div className="flex justify-center  w-[100%] h-[100vh]">
      <div className="w-[390px] md:w-full bg-white mb-20">
        <div className="flex px-6 py-4">
          <div className="items-center my-auto md:hidden">
            <Link to="/userdash">
              <SlArrowLeft />
            </Link>
          </div>
          <h3 className="font-bold flex justify-center mx-auto md:mx-0 text-[22px]">
            Generate Pass
          </h3>
        </div>
        <div className="bg-slate-200 px-6 pb-20 pt-6">
          <form className="flex flex-col gap-5" onSubmit={handleSubmit}>
            <input
              className="rounded-xl w-full py-4 px-4 shadow-slate-400 shadow-sm"
              type="text"
              name="name"
              placeholder="Name"
              value={formData.name}
              onChange={handleInputChange}
            />
            {errors.name && <span className="text-red-500">{errors.name}</span>}

            <select
              className="rounded-xl w-full py-4 px-4 bg-white"
              name="vehicletype"
              value={formData.vehicletype}
              onChange={handleInputChange}
            >
              <option value="">Select a vehicle type</option>
              <option value="Two wheeler">Two wheeler</option>
              <option value="Four wheeler">Four wheeler</option>
            </select>
            {errors.vehicletype && (
              <span className="text-red-500">{errors.vehicletype}</span>
            )}

            <input
              className="rounded-xl w-full py-4 px-4 shadow-slate-400 shadow-sm"
              type="text"
              name="vehicleno"
              placeholder="Vehicle number"
              value={formData.vehicleno}
              onChange={handleInputChange}
            />
            {errors.vehicleno && (
              <span className="text-red-500">{errors.vehicleno}</span>
            )}

            <input
              className="rounded-xl w-full py-4 px-4 bg-white shadow-slate-400 shadow-sm text-slate-400"
              type="date"
              name="date"
              value={formData.date}
              onChange={handleInputChange}
            />
            {errors.date && <span className="text-red-500">{errors.date}</span>}

            <input
              className="rounded-xl w-full py-4 px-4 bg-white shadow-slate-400 shadow-sm text-slate-400"
              type="time"
              name="time"
              value={formData.time}
              onChange={handleInputChange}
            />
            {errors.time && <span className="text-red-500">{errors.time}</span>}

            <button
              type="submit"
              className="bg-[#403F93] text-white w-full flex py-3 rounded-md mt-6"
              disabled={loading}
            >
              <span className="text-center w-full">
                {loading ? "Submitting..." : "Submit"}
              </span>
            </button>
            {error && <p className="text-red-500 mt-2">{error}</p>}
          </form>
        </div>
      </div>
    </div>
  );
};

export default Pass;
